import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { VolumeStack } from './VolumeStack';

/** TODO: replace with the live checkout URL once the sales platform is defined. */
const CHECKOUT_URL = 'https://paid-table-ready-the-5e-megapack-for-game-masters.impultienda.ar/checkout';
const included = ['6 volumes · 57 table-ready sessions', '5 instant-use bonuses', '300 landscape pages, print or tablet', '2, 3 and 4-hour session formulas', '25 planning worksheets', 'Instant PDF download'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-186" data-mp="25t94l6w598g0">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-187" data-mp="20rtlhkdj1c09">
        <div className="text-center" data-id="element-188" data-mp="3h6ldvxaoaj9k">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-189" data-mp="3h5jsozzy0ge4">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-190" data-mp="3vzp5xj5hic9j">
            Everything you need to run{' '}
            <span className="text-gold-deep" data-id="element-191" data-mp="9s8r6yxnhi72">a full year of tables</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-192" data-mp="erbkjm49pzz7">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-193" data-mp="3d97fjl84jsrc">
            <h3 className="font-display text-xl font-semibold text-white sm:text-2xl" data-id="element-194" data-mp="3dasc1ge01lru">
              Paid Table Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-195" data-mp="3n6lnsxjw9b8k">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-196" data-mp="3rz6azg8aoq34">
            <div className="mx-auto max-w-lg rounded-2xl bg-plum-deep" data-id="element-197" data-mp="2uippjoeofb9o">
              <VolumeStack data-id="element-198" data-mp="2ugdb3l84nj1d" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-199" data-mp="2zgr7u74a36k3">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-200" data-mp="2rftcca3hjhf4">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-201" data-mp="2mi1p3tdscjh9">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-202" data-mp="315mqniv0ian2" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-203" data-mp="23ixg2km8uppl">
              <p className="text-[13px] text-ink-soft" data-id="element-204" data-mp="23l0glyl0w18k">
                Costs about the same as one seat at one paid session.
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-plum" data-id="element-205" data-mp="2dgk6a38zu3ov">
                <span className="mt-2.5 font-display text-3xl" data-id="element-206" data-mp="3tv3dm0zv4zbw">$</span>
                <span className="font-display font-semibold text-6xl leading-[0.9] sm:text-7xl" data-id="element-207" data-mp="3txg1eusay3wv">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-208" data-mp="a453vntx2r1">
                  USD
                </span>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-209" data-mp="5aruye0bndjo">
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-210" data-mp="3ngelvqj26y3e">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-211" data-mp="j26garhpbqtw">
                  No subscription
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-212" data-mp="a81pu96hchew">
                  5E compatible
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-213" data-mp="11xwgqa9zkf5o">
                Get Paid Table Ready — only $27
              </CtaButton>
              <p className="mt-3 text-xs text-ink-muted" data-id="element-214" data-mp="3f81tx0503cqg">
                Backed by the money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-215" data-mp="3a7nqjvecgqyr">
                <li className="flex items-center gap-1.5" data-id="element-216" data-mp="359maljc7t7ri">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-217" data-mp="318ixv5pgrrui" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-218" data-mp="3syndys66xspx">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-219" data-mp="3t19kcohci26k" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-220" data-mp="3k4sgm6bb96ku">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-221" data-mp="kjwwx9n8zs0e" />
                  Money-back guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-222" data-mp="23dq32hibndqm">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}